// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomSearch_wrapper__rvGYA","input":"CustomSearch_input__4HUUp"};